<div class="period-wrapper">
  <ng-container #selectorContainer></ng-container>
</div>
